import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Verdant's type scale is named, not t-shirt-sized (`text-body`, `text-h2`,
 * `text-label`). tailwind-merge cannot tell those from colours, so out of the
 * box it files `text-body` under text-colour and silently drops whatever colour
 * was set earlier — in a cva component the size variant comes last, so
 * `text-primary-foreground` disappeared from every button. Teaching it the
 * scale keeps size and colour in separate conflict groups.
 *
 * Keep this list in sync with the `--text-*` entries in `src/index.css`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display',
            'h1',
            'h2',
            'h3',
            'body',
            'caption',
            'label',
            'page-title',
            'page-body',
          ],
        },
      ],
    },
  },
})

/** Conditional classes with later Tailwind utilities winning over earlier ones. */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
